import React, {useEffect, useState, Component} from 'react';

import Switch from '@material-ui/core/Switch';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import FirebaseService from '../../../services/firebase';


import {useInView} from 'react-intersection-observer'; 


const Contact = (props) => {
    const [lastMessage, setLastMessage] = useState(JSON.parse(localStorage.getItem(`${props.contact.id}-lastMessage` )));
    const [contact, setContact] = useState(JSON.parse(localStorage.getItem(props.contact.id)));
    const [subscribeContact, setSubscribeContact] = useState(false);
    const [subscribeLastChatMessage, setSubscribeLastChatMessage] = useState(false);


    const dateOptions = {
        year: "2-digit",
        month: "2-digit",
        day: "numeric",
        hour: "numeric",    
        minute: "2-digit"
    }

    useEffect(() => {
        if (!subscribeLastChatMessage){
            getContactData(props.contact.contactId);
            setSubscribeContact(true);
        } 
        if (!subscribeLastChatMessage){
            FirebaseService.subscribeLastChatMessage(props.contact.id, handleLastMessage);
            setSubscribeLastChatMessage(true);
        }

        if (props.contact.unreadMessages > 0 && props.selected) {
            FirebaseService.updateContact(props.contact.userId, props.contact.id, { unreadMessages: 0 })
        } else {
            
        }
    },[props])

    const getContactData = async (id) => {
        let contact = (await FirebaseService.getUserData(id)).data();
        localStorage.setItem(props.contact.id, JSON.stringify(contact))
        setContact(contact);
    }

    const handleLastMessage = (snapshot) => {

        let message = snapshot.docs.shift()?.data();
        
        if (message) {
            message.datetime = message.timestemp?.toDate();
            localStorage.setItem(`${props.contact.id}-lastMessage`, JSON.stringify(message))
            setLastMessage(message);
        }

    }

    return (
        <div className="contact-item">
            <div className="contact-item-message" style={{width: props.contact.unreadMessages > 0 ? '270px' : '300px'}}>
                <p className="contact-item-date">{lastMessage?.datetime?.toLocaleString('pt-BR', dateOptions)}</p>
                <p className="contact-item-name">{contact?.name}</p>
                <p className="contact-item-lastMessage">{lastMessage?.uid == contact?.userId ? 'Você:' : ''} {lastMessage?.content}</p>
            </div>
            <div className="contact-item-badge">
                {props.contact.unreadMessages > 0 && !props.selected? <span>{props.contact.unreadMessages}</span> : null}
            </div>
        </div>
    )
}

export default Contact;